import { useEffect } from "react";

/**
 * Document-level Escape handler so a modal closes regardless of focus. While
 * `blocked` (e.g. a save is in flight) Escape is ignored.
 */
export function useEscapeToClose(isOpen: boolean, onClose: () => void, blocked = false): void {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e: KeyboardEvent): void => {
      if (e.key === "Escape" && !blocked) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, blocked, onClose]);
}
